export default {
  name: "CalendarSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M2 15.5h28V28a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V15.5zM28 6h-3.5V3.5a1.5 1.5 0 1 0-3 0V6h-11V3.5a1.5 1.5 0 1 0-3 0V6H4a2 2 0 0 0-2 2v4.5h28V8a2 2 0 0 0-2-2z",
  },
}
